import { render, staticRenderFns } from "./AdSupport.vue?vue&type=template&id=ad690e50&scoped=true"
import script from "./AdSupport.vue?vue&type=script&lang=js"
export * from "./AdSupport.vue?vue&type=script&lang=js"
import style0 from "./AdSupport.vue?vue&type=style&index=0&id=ad690e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad690e50",
  null
  
)

export default component.exports